import * as React from "react";
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import FormDropDown from "../formEditComponents/FormDropDown";
import {isDate, isNumeric} from "@progress/kendo-data-query/dist/npm/utils";
import FormTextBoxField from "../formEditComponents/FormTextBoxField";
import FormTextAreaField from "../formEditComponents/FormTextAreaField";
import FormNumBoxField from "../formEditComponents/FormNumBoxField";
import FormDateField from "../formEditComponents/FormDateField";
import {Button} from "@progress/kendo-react-buttons";
import TimeField from "../formEditComponents/FormTimeField";
import config from "../../config/config.json";
import useFetch from "../../tools/UseFetch";
import useOwnRightsStore from "../../stores/OwnRightsStore";

const minValueValidator = value => value >= 0 ? "" : "The value must be 0 or higher";


const mandatoryFieldValidator = value => value != null ? "" : "mandatory field"


const useProjectEditor = props => (
    <FormDropDown
        {...props}
        textField={"ClientProjectName"}
    />
);


const TmsEdit = props => {

    const haveRight = useOwnRightsStore(state => state.haveRight)
    const { data:actual_user, isPending:actual_user_isPending, error:actual_user_error} = useFetch(config.API_URL + 'user/get_own_user', 1)

    const {
        cancelEdit,
        onSubmit,
        item,
        projects,
        authors,
        workTypes,
        ...other
    } = props;

    // item.UnitID = units.find((c) => c.ID === item.UnitID)
    // item.PartnerID = partners.find((c) => c.ID === item.PartnerID)

    const comparisonDate = new Date().getDate() > 5 ? new Date(new Date().getFullYear(), new Date().getMonth(), 1) : new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
    // const haveRight = useOwnRightsStore(state => state.haveRight)

    const unlockedDateFieldValidator = value => {
        if (value != null) {

            if (value >= comparisonDate) {
                return "";
            } else {
                return "Timesheet for this date is locked";
            }

        } else {
            return "mandatory field";
        }
    }


    item.TimeSpentIn = isDate(item.TimeSpentIn) ? item.TimeSpentIn : new Date(0,0,0, Math.floor(item.TimeSpentIn / 60), item.TimeSpentIn % 60)

    const today = new Date()

    //item.TimeSpentIn = new Date(today.getFullYear(),today.getMonth(),today.getDate(),hours,minutes,0)
    // console.log("times X - ", hours, minutes, item.TimeSpentIn)


    const convertDateToUTC = (date) => {

        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();

        const utcDate = new Date(Date.UTC(year, month, day));

        return utcDate;
    };

    const handleSubmit = dataItem => {
        // debugger

        dataItem.Date = convertDateToUTC(dataItem.Date)
        if (isDate(dataItem.TimeSpentIn)) dataItem.TimeSpentIn = 60 * dataItem.TimeSpentIn.getHours() + dataItem.TimeSpentIn.getMinutes()
        // if (isDate(dataItem.TimeSpentIn)) dataItem.TimeSpentIn = 60 * dataItem.TimeSpentIn.getHours() + dataItem.TimeSpentIn.getMinutes()
        // dataItem.TimeSpentOut = dataItem.TimeSpentIn

        if (!isNumeric(dataItem.ProjectID)) dataItem.ProjectID = dataItem.ProjectID.ID
        if (!isNumeric(dataItem.AuthorID)) dataItem.AuthorID = dataItem.AuthorID.ID

        if (dataItem.WorkTypeID !== null && dataItem.WorkTypeID !== undefined) {
            if (!isNumeric(dataItem.WorkTypeID)) dataItem.WorkTypeID = dataItem.WorkTypeID.ID
        }
        else {
            dataItem.WorkTypeID = 1
        }

        onSubmit(dataItem)
    }

    var locked = false
    var title = ``
    if (item.ID === null) {
        title = "Copy TMS"
    }
    else if (item.ID === undefined) {
        title = "Create new TMS"
    }
    else {
        // console.log("a2", item.AuthorID, actual_user.ID, haveRight("TMS_Fill_For_Others"))
        title = `Edit TMS: ${item.ID}`
        if ((item.Date < comparisonDate) || (item.AuthorID !== actual_user?.ID && !haveRight("TMS_Fill_For_Others"))) {
            title += ` - LOCKED`
            locked = true
        }
    }

    // const { data:partners, isPending, error} = useFetch(config.API_URL + 'partner/', 1)

    return (

        <div className="edit-form-outter">
            <Form initialValues={item} onSubmit={handleSubmit} render={renderProps =>

            // <Window title={title} onClose={cancelEdit}
            //         initialHeight={1000}
            //         initialWidth={600}
            //         modal={true}
            // >

            <>
                <div className="editForm">

                    <FormElement horizontal={false}>

                        {projects && <FieldWrapper><Field disabled={true} name={"ProjectID"} label={"Project"} textField={"Name"} dataItemKey={"id"} component={useProjectEditor} listData={projects} /></FieldWrapper>}
                        {authors && <FieldWrapper><Field disabled={true} name={"AuthorID"} label={"Autor"} textField={"Name"} dataItemKey={"id"} component={FormDropDown} listData={authors} validator={mandatoryFieldValidator} /></FieldWrapper>}



                        {/*<FieldWrapper><Field name={"Code"} component={FormTextBoxField}  label={"Code"} /></FieldWrapper>*/}
                        {/*<FieldWrapper><Field name={"Category"} component={FormTextBoxField}  label={"Category"} /></FieldWrapper>*/}

                        <FieldWrapper><Field disabled={locked} name={"Date"} component={FormDateField}  label={"Date"} validator={unlockedDateFieldValidator} /></FieldWrapper>

                        {/*{workTypes && <FieldWrapper><Field name={"WorkTypeID"} label={"WorkTypeID"} textField={"Name"} dataItemKey={"id"} component={FormDropDown} listData={workTypes} validator={mandatoryFieldValidator} /></FieldWrapper>}*/}

                        <FieldWrapper><Field disabled={locked} name={"TimeSpentIn"} component={TimeField} steps={{"hour":1, "minute":5}} label={"Trvani"} /></FieldWrapper>
                        {/*<FieldWrapper><Field name={"TimeSpentOut"} component={FormNumBoxField}  label={"TimeSpentOut"} /></FieldWrapper>*/}

                        <FieldWrapper><Field disabled={locked} name={"Note"} component={FormTextAreaField}  label={"Text"} /></FieldWrapper>
                        {/*<FieldWrapper><Field name={"Tags"} component={FormTextBoxField}  label={"Tagy"} /></FieldWrapper>*/}

                        {/*<FieldWrapper><Field name={"InvoiceNum"} component={FormTextBoxField}  label={"InvoiceNum"} /></FieldWrapper>*/}

                    </FormElement>

                </div>

                <div className={"edit-form-buttons"}>
                    <Button type={"submit"} themeColor={"success"} disabled={locked || !renderProps.allowSubmit} onClick={renderProps.onSubmit} icon="save" >
                        Update
                    </Button>
                    <Button onClick={cancelEdit} themeColor={"secondary"} icon="cancel" >
                        Cancel
                    </Button>
                </div>

                </>

                } {...other} />
        </div>

    );
};
export default TmsEdit;